<template>
    <div class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="primary" @click="addClick">
                <i class="fa-solid fa-plus"></i>
                {{ $LANG.Get('buttons.add') }}
            </NevsButton>
            <NevsButton class="primary" @click="excelClick">
                <i class="fa-solid fa-file-excel"></i>
                {{ $LANG.Get('buttons.excel') }}
            </NevsButton>
        </div>
        <NevsCard>
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadTable">
                <tr class="nevs-table-filters">
                    <td>
                        <NevsTextField v-model="tableData.filters.name"></NevsTextField>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr v-for="(item, key) in tableData.records" :key="key">
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.name }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.duration }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.price }}</td>
                    <td class="nevs-table-actions">
                        <span :title="$LANG.Get('tooltips.openInNewWindow')" class="nevs-table-button"
                              @click="openClick(item.id, true)"><i class="fa-solid fa-up-right-from-square"></i></span>
                        <span :title="$LANG.Get('tooltips.delete')" class="nevs-table-button"
                              @click="deleteClick(item)"><i class="fa-solid fa-trash"></i></span>
                    </td>
                </tr>
            </NevsTable>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";

export default {
    name: "ModuleMemberships",
    components: {NevsTextField, NevsTable, NevsButton, NevsCard},
    data() {
        return {
            tableData: {
                fields: [
                    {
                        name: 'name',
                        label: this.$LANG.Get('fields.name')
                    },
                    {
                        name: 'duration',
                        label: this.$LANG.Get('fields.durationMonths'),
                        width: '150px'
                    },
                    {
                        name: 'price',
                        label: this.$LANG.Get('fields.price'),
                        width: '120px'
                    },
                    {
                        name: 'actions',
                        width: '80px',
                        label: '',
                        sortable: false
                    }
                ],
                filters: {
                    name: ''
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                defaultSort: {
                    field: 'name',
                    descending: false
                },
                filterTimer: null,
                height: '0px'
            },
            crossTabHandle: null
        }
    },
    watch: {
        'tableData.filters': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadTable(vm.tableData.lastRequest);
                }, 500);
            },
            deep: true
        }
    },
    methods: {
        openClick(id, newWindow = false) {
            if (newWindow) {
                let routeData = this.$router.resolve('/memberships/' + id);
                window.open(routeData.href);
            } else {
                this.$router.push('/memberships/' + id);
            }
        },
        addClick() {
            this.$router.push('/memberships/0');
        },
        excelClick() {
            let excelRequest = JSON.parse(JSON.stringify(this.tableData.lastRequest));
            excelRequest.rowsPerPage = 0;
            let vm = this;
            vm.$API.APICall('get', 'memberships/excel', excelRequest, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        deleteClick(item) {
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm',
                text: this.$LANG.Get('alerts.membershipDeletionQuestion'),
                callback: (response) => {
                    if (response) {
                        this.$API.APICall('delete', 'memberships/' + item.id, {}, (data, success) => {
                            if (success) {
                                this.$CROSS_TAB_BUS.TriggerEvent('reload-memberships', {});
                            } else {
                                this.$HELPERS.HandleServerError(this, data);
                            }
                        });
                    }
                }
            });
        },
        reloadTable(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'memberships', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        resolveWindowResize() {
            this.tableData.height = window.innerHeight - 205 + 'px';
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', []);
        this.$store.commit('selectMenu', 'memberships');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.memberships'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
        let vm = this;
        this.crossTabHandle = this.$CROSS_TAB_BUS.ListenToEvent('reload-memberships', () => {
            vm.reloadTable(vm.tableData.lastRequest);
        });
    },
    unmounted() {
        if (this.crossTabHandle !== null) {
            this.$CROSS_TAB_BUS.UnbindEvent(this.crossTabHandle);
        }
    }
}
</script>

<style scoped>
</style>
